<template>
  <v-app class="default-page-container">
    <div class="default-wrapper">
      <div class="left-side">
        <img src="../statics/logo-ciitizen.svg" class="logo-height" id="ciitizen-logo" />
      </div>
      <div class="login-divider" />
      <div class="right-side-wrapper">
        <router-view name="body" />
        <div class="terms-privacy" v-if="!$route.path.includes('external-share')">
          <!-- Was asked to remove, but possibility of it coming back - mle -->
          <!-- <a
            class="hyperlink-style"
            href="https://www.ciitizen.com/privacy/index.html"
            target="_blank"
            id="terms-privacy"
            >Terms & Privacy</a
          >
          / -->
          <a href="mailto:help@ciitizen.com" class="hyperlink-style" id="contact-support"
            >Contact Support</a
          >
        </div>
      </div>
    </div>
    <div class="name-container" id="year-invitae">{{ year }} Invitae</div>
    <div class="disclaimer" id="best-viewer">
      Best viewed in the latest versions of Safari, Mozilla Firefox, and Google Chrome
    </div>
  </v-app>
</template>

<script>
export default {
  name: 'DefaultLayout',
  computed: {
    year() {
      const date = new Date()
      return date.getFullYear()
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus" scoped>
.default-page-container
  display: flex;
  flex-direction: column
  height: 100vh
  left: 0

.default-wrapper
  display: flex
  height: 90%
  justify-content: center
  align-items: center

.logo-height
  height: 80px

.login-divider
  width: 1px
  height: 90%
  background: #d2d2d2
  margin: 0 80px

.disclaimer
  font-size: 13px
  font-weight: 400
  text-align: center
  padding: 10px 20px
  color: #80868B
  line-height: 16px
  margin-bottom: 40px

.terms-privacy
  font-size: 14px
  font-weight: 400
  text-align: center
  margin-top: 20px
  color: #80868B
  line-height: 16px

.right-side
  width: 100%

.right-side-wrapper
  display: block
  /*width: 300px*/

.name-container
 font-style: normal
 font-weight: normal
 font-size: 14px
 line-height: 16px
 color:#80868B
 text-align: center

.hyperlink-style
  text-decoration: none
  color: #80868B

/* Handling medium sized screens */
@media only screen and (max-width: 769px)
  .default-wrapper
    padding: 0 40px
  .logo-height
    height: 60px
  .right-side-wrapper
    display: block

/* For mobile screens */
@media only screen and (max-width: 561px)
  .logo-height
    height: 30px
  .login-divider
    display: none
  .default-wrapper
    display: flex
    flex-direction: column
    justify-content: flex-start
    padding: 24px
  .right-side
    width: 325px
    padding-top: 40px
  .right-side-wrapper
    display: contents
</style>
